import { render, staticRenderFns } from "./GooPagination2.vue?vue&type=template&id=6ff01500&scoped=true&lang=pug&"
import script from "./GooPagination2.vue?vue&type=script&lang=js&"
export * from "./GooPagination2.vue?vue&type=script&lang=js&"
import style0 from "./GooPagination2.vue?vue&type=style&index=0&id=6ff01500&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff01500",
  null
  
)

export default component.exports